export default function NotFound() {
    return (
        <div className="space-y-5 sm:p-10 p-0">
        <h1 className="text-6xl">Oops!</h1>
        <p className="text-4xl">404 Page not found</p>
        </div>
    );
}